<template>
  <div class="login-page">
    <!-- <app-navbar></app-navbar> -->
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <form @submit.prevent="login">
                <card type="login">
                  <h3 slot="header" class="header text-center">Login</h3>
                  <fg-input v-model="form.username" addon-left-icon="nc-icon nc-single-02"
                            placeholder="Username/Email"></fg-input>
                  <fg-input v-model="form.password" addon-left-icon="nc-icon nc-key-25" placeholder="Password"
                            type="password" autocomplete="off"></fg-input>
                  <p-button native-type="submit" slot="footer" type="success" round block class="mb-3">LOGIN</p-button>
                </card>
              </form>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div class="full-page-background" style="background-image: url(static/img/shorepower-logo-bg.png) "></div>
      </div>
    </div>
  </div>
</template>
<script>
    import { Card, Checkbox, Button } from 'src/components/UIComponents';
    // import AppNavbar from './Layout/AppNavbar'
    import AppFooter from './Layout/AppFooter'
    import { mapActions } from 'vuex';
    import swal from 'sweetalert2'

    export default {
        components: {
            Card,
            // AppNavbar,
            AppFooter,
            [Checkbox.name]: Checkbox,
            [Button.name]: Button
        },
        methods: {
            ...mapActions('auth', [
            'retrieveToken', // -> this.foo()
            'retrieveUserPermissions',
            'destroyToken',
            'retrieveUserGeneralPermissions'
            ]),
            toggleNavbar() {
                document.body.classList.toggle('nav-open')
            },
            closeMenu() {
                document.body.classList.remove('nav-open')
                document.body.classList.remove('off-canvas-sidebar')
            },
            login() {
                this.retrieveToken({
                    username_or_email: this.form.username,
                    password: this.form.password
                }).then(response => {
                    return this.retrieveUserPermissions()
                }).then(response => {
                    return this.retrieveUserGeneralPermissions();
                }).then(response => {
                    this.$router.push({ name: 'Overview' })
                }).catch(err => {
                    this.destroyToken();
                    if (err.response) {
                    // Request made and server responded
                        const error = err.response.data.error
                        const status_code = err.response.status
                        if ('errors' in err.response.data) {
                            this.$notify({
                                group: 'general',
                                title: 'Bad Request',
                                text: err.response.data.message,
                                type: 'error'
                            });
                        } else if (status_code == 500) {
                            this.$notify({
                                group: 'general',
                                title: 'Server Error',
                                text: 'Internal Server Error. Please try again later..',
                                type: 'error'
                            });
                        } else {
                            this.$notify({
                                group: 'general',
                                title: 'Bad Request',
                                text: error,
                                type: 'error'
                            }); 
                        }
                    } else if (err.request) {
                    // The request was made but no response was received
                        this.$notify({
                            group: 'general',
                            title: 'Server Error',
                            text: error,
                            type: 'error'
                        }); 
                    } else {
                    // Something happened in setting up the request that triggered an Error
                        this.$notify({
                            group: 'general',
                            title: 'Error',
                            text: err.message,
                            type: 'error'
                        }); 
                    }
                })
            }
        },
    data() {
      return {
        form: {
          username: '',
          password: ''
        }
      }
    },
    beforeDestroy() {
      this.closeMenu()
    }
  }
</script>
<style>
</style>
